import { Api } from '@/infrastructure';
import { CompanyRecreationPlan } from '@/types';

type UseCompanyRecreationPlanHook = {
  fetchCompanyRecreationPlan: (id: number) => Promise<CompanyRecreationPlan>;
};

export const useCompanyRecreationPlan = (): UseCompanyRecreationPlanHook => {
  const fetchCompanyRecreationPlan = async (
    id: number
  ): Promise<CompanyRecreationPlan> => {
    const response = await Api.get<CompanyRecreationPlan>(
      `company_recreation_plans/${id}`,
      'customer'
    );
    return response.data;
  };

  return { fetchCompanyRecreationPlan };
};
